import React, { Component } from "react";
import PropTypes from "prop-types";
import { hot } from "react-hot-loader";
import WishlistCardsContainer from "./WishlistCards";
import AdminBarContainer from "./AdminBar";

class RootContainer extends Component {
  static propTypes = {
    session: PropTypes.object.isRequired,
    emarsysMappingCustomerId: PropTypes.string.isRequired,
    isProductPage: PropTypes.bool.isRequired,
    programmeId: PropTypes.string,
  };

  static defaultProps = {
    session: {
      theme: "default",
    },
  };

  render() {
    const { session } = this.props;

    return (
      <>
        <WishlistCardsContainer session={session} />
        <AdminBarContainer session={session} />
      </>
    );
  }
}

export default hot(module)(RootContainer);
